// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contact-fields-item h5{font-size:1.3rem}.contact-fields-item+.contact-fields-item{border-top:1px solid #5e789e;padding-top:32px}.contact-fields-container{flex:1;margin-right:15px}\n", ""]);
// Exports
module.exports = exports;
